import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { api } from './api';

interface AuthCtx {
  authed: boolean;
  loading: boolean;
  login: (password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const Ctx = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [authed, setAuthed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/me').then(() => setAuthed(true)).catch(() => setAuthed(false)).finally(() => setLoading(false));
    const onUnauth = () => setAuthed(false);
    window.addEventListener('app:unauthorized', onUnauth);
    return () => window.removeEventListener('app:unauthorized', onUnauth);
  }, []);

  const login = async (password: string) => {
    await api.post('/login', { password });
    setAuthed(true);
  };

  const logout = async () => {
    await api.post('/logout');
    setAuthed(false);
  };

  return <Ctx.Provider value={{ authed, loading, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error('AuthProvider ausente');
  return v;
};
